// extracted by mini-css-extract-plugin
export var wordContainer = "_iy-0";